import { useEffect } from 'react'
import { toast } from 'sonner'
import type { DictionaryStatus } from '../types/dictionary-status'

/**
 * Shows the "Couldn't load the dictionary" toast (Figma "Dictionary Load Failure") each time the
 * Edit Dictionary tab is open on a failed load: on entering the tab, and when a reopen retry fails.
 */
export function useDictionaryLoadErrorToast(status: DictionaryStatus) {
  useEffect(() => {
    if (status !== 'error') return

    toast.error("Couldn't load the dictionary.", {
      description: "Your custom words aren't available right now. Try again.",
    })
  }, [status])
}
